import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../../locales/translations';

const prefix = 'studentDocuments';

export function useTexts() {
  const { t } = useTranslation(TranslationsKeys.STUDENT_FILE_TABS);
  return useMemo(
    () => ({
      tabTitle: t(`${prefix}.tabTitle`),
      documentsTuitionTitle: t(`${prefix}.documentsTuitionTitle`),
      documentsOthersTitle: t(`${prefix}.documentsOthersTitle`),
      createStudentDocument: t(`${prefix}.createStudentDocument`),
      noResults: t(`${prefix}.noResults`),
      documentsTuitionTable: {
        name: t(`${prefix}.documentsTuitionTable.name`),
        period: t(`${prefix}.documentsTuitionTable.period`),
        studyPlan: t(`${prefix}.documentsTuitionTable.studyPlan`),
        fileName: t(`${prefix}.documentsTuitionTable.fileName`),
        action: t(`${prefix}.documentsTuitionTable.action`),
      },
      documentsOthersTable: {
        name: t(`${prefix}.documentsOthersTable.name`),
        description: t(`${prefix}.documentsOthersTable.description`),
        fileName: t(`${prefix}.documentsOthersTable.fileName`),
        action: t(`${prefix}.documentsOthersTable.action`),
      },
      toast: {
        success: t(`${prefix}.toast.success`),
        error: t(`${prefix}.toast.error`),
      },
    }),
    [t],
  );
}
